import { Treasure } from "@/game/entities/Treasure";

/**
 * 宝箱のDOM描画
 *
 * CSS: field.css の .chest-svg セクション
 * 構造: .chest-svg > .lid + .box + .lock + .sparkle ×3
 */
export class TreasureRenderer {
  private element: HTMLDivElement;

  constructor(private treasure: Treasure) {
    this.element = this.createElement();
  }

  private createElement(): HTMLDivElement {
    const el = document.createElement("div");
    el.className = "chest-svg";

    const lid = document.createElement("div");
    lid.className = "lid";
    const box = document.createElement("div");
    box.className = "box";
    const lock = document.createElement("div");
    lock.className = "lock";

    el.appendChild(lid);
    el.appendChild(box);
    el.appendChild(lock);

    for (let i = 0; i < 3; i++) {
      const sparkle = document.createElement("div");
      sparkle.className = "sparkle";
      el.appendChild(sparkle);
    }

    return el;
  }

  getElement(): HTMLDivElement {
    return this.element;
  }

  getGridX(): number {
    return this.treasure.gridX;
  }

  getGridY(): number {
    return this.treasure.gridY;
  }
}
